{
    "Accessibility Menu": "ადაპტირებული მენიუ",
    "Reset settings": "პარამეტრების დაბრუნება",
    "Close": "დახურვა",
    "Content Adjustments": "შიგთავსის მორგება",
    "Adjust Font Size": "ფონტის ზომის მორგება",
    "Highlight Title": "სათაურების გამოყოფა",
    "Highlight Links": "ბმულების გამოყოფა",
    "Readable Font": "წაკითხვადი ტექსტები",
    "Color Adjustments": "ფერების მორგება",
    "Dark Contrast": "ბნელი ელფერი",
    "Light Contrast": "ნათელი ელფერი",
    "High Contrast": "მაღალი ელფერი",
    "High Saturation": "მაღალი გაჯერება",
    "Low Saturation": "დაბალი გაჯერება",
    "Monochrome": "ერთფეროვანი გამოსახულება",
    "Protanopia": "პროტანოპია",
    "Deuteranopia": "დეიტერანოპია",
    "Tritanopia": "ტრიტანოპია",
    "Visual & Navigation Aids": "ვიზუალური და ნავიგაციის საშუალებები",
    "Additional Tools": "დამატებითი ხელსაწყოები",
    "Reading Guide": "კითხვის გამყოლი ზოლი",
    "Stop Animations": "ანიმაციების გაჩერება",
    "Big Cursor": "დიდი კურსორი",
    "Screen Reader": "ეკრანის მკითხველი",
    "Hide Images": "სურათების დამალვა",
    "Image Tooltips": "სურათების ახსნები",
    "Page Structure": "გვერდის სტრუქტურა",
    "Super Focus": "სუპერ ფოკუსი",
    "Magnifier": "გამადიდებელი",
    "Increase Font Size": "ფონტის ზომის გაზრდა",
    "Decrease Font Size": "ფონტის ზომის შემცირება",
    "Letter Spacing": "ასოებს შორის დაშორება",
    "Line Height": "ხაზის სიმაღლე",
    "Font Weight": "ფონტის წონა",
    "Dyslexia Font": "დისლექსიური ფონტი",
    "Language": "ენა",
    "Open Accessibility Menu": "გახსენი ადაპტირებული მენიუ",
    "Accessibility Profiles": "ადაპტაციის პროფილები",
    "Seizure Safe Profile": "გულყრისგან უსაფრთხო პროფილი",
    "Stops animations and reduces color saturation.": "ჩერდება ანიმაციები და მცირდება ფერების გაჯერება.",
    "Blind Profile": "სრულყოფა უსინათლოთათვის",
    "Activates the screen reader for auditory navigation.": "ააქტიურებს ეკრანის მკითხველს სმენითი ნავიგაციისთვის.",
    "Visually Impaired Profile": "სუსტმხედველთა პროფილი",
    "Enhances contrast and readability for low vision.": "აუმჯობესებს კონტრასტსა და წასაკითხობლობას სუსტმხედველთათვის.",
    "ADHD Friendly Profile": "ADHD-ს მორგებული პროფილი",
    "Reduces distractions for better focus.": "ამცირებს გაფანტვას უკეთ კონცენტრაციისთვის.",
    "Cognitive & Learning Profile": "კოგნიტური და სასწავლო პროფილი",
    "Helpful tools for reading and comprehension.": "სასარგებლო ხელსაწყოები კითხვისა და გაგებისთვის.",
    "Motor Impaired Profile": "მოტორული შეზღუდვების პროფილი",
    "Optimizes the site for keyboard-only navigation.": "ოპტიმიზებს საიტს მხოლოდ კლავიატურით ნავიგაციისთვის.",
    "Headings": "სათაურები",
    "Landmarks": "ღირსშესანიშნავი წერტილები",
    "Links": "ბმულები",
    "Focus element": "ელემენტის ფოკუსი",
    "Visit link": "ბმულის გახსნა"
}
